import React from 'react';
import { LayoutDashboard, Gavel, FileCheck, Users, FileText, Download, Calendar, BarChart3, PieChart } from 'lucide-react';
import { DashboardLayout } from '../../components/DashboardLayout';
export function ReportsPage() {
  const navItems = [{
    label: 'Dashboard',
    icon: LayoutDashboard,
    path: '/authority'
  }, {
    label: 'Auctions',
    icon: Gavel,
    path: '/authority/auctions',
    badge: '3 Active'
  }, {
    label: 'Compliance',
    icon: FileCheck,
    path: '/authority/compliance'
  }, {
    label: 'Public Listings',
    icon: Users,
    path: '/authority/listings'
  }, {
    label: 'Reports',
    icon: FileText,
    path: '/authority/reports'
  }];
  return <DashboardLayout title="Authority Portal" personaLabel="GOVT AUTHORITY" personaColor="bg-orange-100 text-orange-800 border-orange-200" navItems={navItems} userInitials="GA" data-id="element-2817">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-8" data-id="element-2818">
        <h1 className="text-2xl font-bold" data-id="element-2819">Authority Reports</h1>
        <div className="flex gap-2" data-id="element-2820">
          <button className="flex items-center gap-2 px-3 py-2 border border-gray-300 bg-white text-sm font-medium hover:bg-gray-50" data-id="element-2821">
            <Calendar className="w-4 h-4" data-id="element-2822" /> FY 2024-25
          </button>
          <button className="flex items-center gap-2 px-3 py-2 bg-[#1f2933] text-white text-sm font-bold hover:bg-gray-800" data-id="element-2823">
            <Download className="w-4 h-4" data-id="element-2824" /> Export All
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-8" data-id="element-2825">
        <div className="bg-white border border-gray-300 p-6" data-id="element-2826">
          <h3 className="font-bold text-lg mb-6 flex items-center gap-2" data-id="element-2827">
            <BarChart3 className="w-5 h-5" data-id="element-2828" /> Land Revenue Trends
          </h3>
          <div className="h-64 border-2 border-dashed border-gray-200 bg-gray-50 flex items-center justify-center" data-id="element-2829">
            <span className="text-gray-400 font-mono" data-id="element-2830">[Revenue Bar Chart]</span>
          </div>
          <div className="grid grid-cols-3 gap-4 mt-6 text-center" data-id="element-2831">
            <div data-id="element-2832">
              <div className="text-xs text-gray-500 uppercase" data-id="element-2833">
                Total Revenue
              </div>
              <div className="font-bold text-lg" data-id="element-2834">₹ 42.5 Cr</div>
            </div>
            <div data-id="element-2835">
              <div className="text-xs text-gray-500 uppercase" data-id="element-2836">
                Auction Sales
              </div>
              <div className="font-bold text-lg" data-id="element-2837">₹ 28.2 Cr</div>
            </div>
            <div data-id="element-2838">
              <div className="text-xs text-gray-500 uppercase" data-id="element-2839">Fees & Tax</div>
              <div className="font-bold text-lg" data-id="element-2840">₹ 14.3 Cr</div>
            </div>
          </div>
        </div>

        <div className="bg-white border border-gray-300 p-6" data-id="element-2841">
          <h3 className="font-bold text-lg mb-6 flex items-center gap-2" data-id="element-2842">
            <PieChart className="w-5 h-5" data-id="element-2843" /> Compliance Overview
          </h3>
          <div className="h-64 border-2 border-dashed border-gray-200 bg-gray-50 flex items-center justify-center" data-id="element-2844">
            <span className="text-gray-400 font-mono" data-id="element-2845">
              [Compliance Pie Chart]
            </span>
          </div>
          <div className="mt-6 space-y-2" data-id="element-2846">
            <div className="flex justify-between text-sm" data-id="element-2847">
              <span data-id="element-2848">Fully Compliant</span>
              <span className="font-bold text-green-600" data-id="element-2849">72%</span>
            </div>
            <div className="flex justify-between text-sm" data-id="element-2850">
              <span data-id="element-2851">Minor Violations</span>
              <span className="font-bold text-yellow-600" data-id="element-2852">18%</span>
            </div>
            <div className="flex justify-between text-sm" data-id="element-2853">
              <span data-id="element-2854">Critical Issues</span>
              <span className="font-bold text-red-600" data-id="element-2855">10%</span>
            </div>
          </div>
        </div>
      </div>
    </DashboardLayout>;
}